/**
 * １次２次紐付け
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'
import { BigNumber } from 'bignumber.js';
import {
  DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_REMOVE_ITEM,
  DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_SET_ITEM,
  DRIVER_MANIFEST_TARGET_CHECKED_ITEMS
} from "../../../mutation-types/driver-types";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/linkages`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    /**
     * 検索パラメータ
     */
    condition: {
      limit: 50,
      disposer_id: null,
      disposer_location_id: null,
      disposer_location_code: null,
      disposal_category_codes: [],
      disposal_subcategory_ids: [],
      item_ids: null,
      second_consign: null,
      collected_date_from: null,
      collected_date_to: null,
      disposal_completed_date_from: null,
      disposal_completed_date_to: null,
      disposal_method_id: null,
      recycling: null,
      waste_name: null,
      manifest_type: null,
      manifest_ids: null,
      sort_type: 'collected_date_desc',
      custom_labels_1: null,
      custom_labels_2: null,
      custom_labels_3: null,
      custom_labels_4: null,
      custom_labels_5: null,
      custom_labels_6: null,
      custom_labels_1_unregistered: false,
      custom_labels_2_unregistered: false,
      custom_labels_3_unregistered: false,
      custom_labels_4_unregistered: false,
      custom_labels_5_unregistered: false,
      custom_labels_6_unregistered: false,
      manifest_search_keyword: null,
      type_of_manifest: 'first_manifest',
      final_report_state: 'unreported',
    },
    /** チェックボックス ONリスト */

    /** ２次委託量が指定されて検索された場合の対象情報 */
    checkedTargetResults: [],

    selectedItems: [],
    quantityTotal: 0,
    individualItems: [],
  }
}

const manifest_linkage = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    quantityTotal: ( state ) => {
      return state.quantityTotal
    },
    selectedMembers: (state) => {
      return state.selectedItems
    }
  },
  actions: {
    /**
     * １次２次紐付け一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param conditions { Object } 検索条件
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { conditions }) {

      console.log("conditions", conditions)

      dispatch('saveCondition', { conditions: conditions })

      const params = {
        ...conditions,
        type_of_manifest: conditions.type_of_manifest !== undefined ? conditions.type_of_manifest : state.condition.type_of_manifest,
        final_report_state: conditions.final_report_state !== undefined ? conditions.final_report_state : state.condition.final_report_state,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_MANIFEST_LINKAGE_PAGINATION, { content })
          resolve(data.content)
        })
      })
    },
    /**
     * １次２次紐付け 初期データ取得
     * @return {Promise<unknown>}
     */
    new ({ commit }, { disposer_id, disposer_location_code  }) {
      const params = { disposer_id: disposer_id, disposer_location_code: disposer_location_code }
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, {params: params}).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit, state }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          const content = data.content
          commit('freelySnackbar/showInfo', {
            title: '登録しました',
            subTitle: 'DXEマニ番号',
            messages: [content.manifest_id],
            enableCopy: true,
            timeout: 6000,
          }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 検索パラメータの保存
     * @param commit
     * @param state
     * @param conditions { Object } 検索条件
     */
    saveCondition ({ commit, state }, { conditions }) {
      const _disposer_id = ( conditions.disposer_id !== undefined ) ? conditions.disposer_id : state.condition.disposer_id
      const _disposer_location_id = ( conditions.disposer_location_id !== undefined ) ? conditions.disposer_location_id : state.condition.disposer_location_id
      const _disposer_location_code = ( conditions.disposer_location_code !== undefined ) ? conditions.disposer_location_code : state.condition.disposer_location_code
      const _disposal_category_codes = (conditions.disposal_category_codes !== undefined) ? conditions.disposal_category_codes : state.condition.disposal_category_codes;
      const _disposal_subcategory_ids = (conditions.disposal_subcategory_ids !== undefined) ? conditions.disposal_subcategory_ids : state.condition.disposal_subcategory_ids;
      const _item_ids = ( conditions.item_ids !== undefined ) ? conditions.item_ids : state.condition.item_ids
      const _second_consign = ( conditions.second_consign !== undefined ) ? conditions.second_consign : state.condition.second_consign
      const _collected_date_from = ( conditions.collected_date_from !== undefined ) ? conditions.collected_date_from : state.condition.collected_date_from
      const _collected_date_to = ( conditions.collected_date_to !== undefined ) ? conditions.collected_date_to : state.condition.collected_date_to
      const _disposal_completed_date_from = ( conditions.disposal_completed_date_from !== undefined ) ? conditions.disposal_completed_date_from : state.condition.disposal_completed_date_from
      const _disposal_completed_date_to = ( conditions.disposal_completed_date_to !== undefined ) ? conditions.disposal_completed_date_to : state.condition.disposal_completed_date_to
      const _disposal_method_id = ( conditions.disposal_method_id !== undefined ) ? conditions.disposal_method_id : state.condition.disposal_method_id
      const _recycling = (conditions.recycling !== undefined) ? conditions.recycling : state.condition.recycling
      const _waste_name = (conditions.waste_name !== undefined) ? conditions.waste_name : state.condition.waste_name
      const _manifest_type = (conditions.manifest_type !== undefined) ? conditions.manifest_type : state.condition.manifest_type
      const _manifest_ids = (conditions.manifest_ids !== undefined) ? conditions.manifest_ids : state.condition.manifest_ids
      const _sort_type = (conditions.sort_type !== undefined) ? conditions.sort_type: state.condition.sort_type
      const _custom_labels_1 = (conditions.custom_labels_1 !== undefined) ? conditions.custom_labels_1 : state.condition.custom_labels_1
      const _custom_labels_2 = (conditions.custom_labels_2 !== undefined) ? conditions.custom_labels_2 : state.condition.custom_labels_2
      const _custom_labels_3 = (conditions.custom_labels_3 !== undefined) ? conditions.custom_labels_3 : state.condition.custom_labels_3
      const _custom_labels_4 = (conditions.custom_labels_4 !== undefined) ? conditions.custom_labels_4 : state.condition.custom_labels_4
      const _custom_labels_5 = (conditions.custom_labels_5 !== undefined) ? conditions.custom_labels_5 : state.condition.custom_labels_5
      const _custom_labels_6 = (conditions.custom_labels_6 !== undefined) ? conditions.custom_labels_6 : state.condition.custom_labels_6
      const _custom_labels_1_unregistered = ( conditions.custom_labels_1_unregistered !== undefined ) ? conditions.custom_labels_1_unregistered : state.condition.custom_labels_1_unregistered
      const _custom_labels_2_unregistered = ( conditions.custom_labels_2_unregistered !== undefined ) ? conditions.custom_labels_2_unregistered : state.condition.custom_labels_2_unregistered
      const _custom_labels_3_unregistered = ( conditions.custom_labels_3_unregistered !== undefined ) ? conditions.custom_labels_3_unregistered : state.condition.custom_labels_3_unregistered
      const _custom_labels_4_unregistered = ( conditions.custom_labels_4_unregistered !== undefined ) ? conditions.custom_labels_4_unregistered : state.condition.custom_labels_4_unregistered
      const _custom_labels_5_unregistered = ( conditions.custom_labels_5_unregistered !== undefined ) ? conditions.custom_labels_5_unregistered : state.condition.custom_labels_5_unregistered
      const _custom_labels_6_unregistered = ( conditions.custom_labels_6_unregistered !== undefined ) ? conditions.custom_labels_6_unregistered : state.condition.custom_labels_6_unregistered
      const _manifest_search_keyword = ( conditions.manifest_search_keyword !== undefined ) ? conditions.manifest_search_keyword : state.condition.manifest_search_keyword
      const _with_associated = ( conditions.with_associated !== undefined ) ? conditions.with_associated : state.condition.with_associated
      const _type_of_manifest = ( conditions.type_of_manifest !== undefined ) ? conditions.type_of_manifest : state.condition.type_of_manifest
      const _final_report_state = ( conditions.final_report_state !== undefined ) ? conditions.final_report_state : state.condition.final_report_state
      const _limit = (conditions.limit !== undefined) ? conditions.limit : state.condition.limit
      const params = {
        disposer_id: _disposer_id,
        disposer_location_id: _disposer_location_id,
        disposer_location_code: _disposer_location_code,
        disposal_category_codes: _disposal_category_codes,
        disposal_subcategory_ids: _disposal_subcategory_ids,
        item_ids: _item_ids,
        second_consign: _second_consign,
        collected_date_from: _collected_date_from,
        collected_date_to: _collected_date_to,
        disposal_completed_date_from: _disposal_completed_date_from,
        disposal_completed_date_to: _disposal_completed_date_to,
        disposal_method_id: _disposal_method_id,
        recycling: _recycling,
        waste_name: _waste_name,
        manifest_type: _manifest_type,
        manifest_ids: _manifest_ids,
        sort_type: _sort_type,
        custom_labels_1: _custom_labels_1,
        custom_labels_2: _custom_labels_2,
        custom_labels_3: _custom_labels_3,
        custom_labels_4: _custom_labels_4,
        custom_labels_5: _custom_labels_5,
        custom_labels_6: _custom_labels_6,
        custom_labels_1_unregistered: _custom_labels_1_unregistered,
        custom_labels_2_unregistered: _custom_labels_2_unregistered,
        custom_labels_3_unregistered: _custom_labels_3_unregistered,
        custom_labels_4_unregistered: _custom_labels_4_unregistered,
        custom_labels_5_unregistered: _custom_labels_5_unregistered,
        custom_labels_6_unregistered: _custom_labels_6_unregistered,
        manifest_search_keyword: _manifest_search_keyword,
        with_associated: _with_associated,
        type_of_manifest: _type_of_manifest,
        final_report_state: _final_report_state,
        limit: _limit
      }
      commit(types.DRIVER_MANIFEST_LINKAGE_CONDITION, { conditions: params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_MANIFEST_LINKAGE_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_MANIFEST_LINKAGE_RESET_PAGINATION)
    },
    /**
     * 個別登録
     * @param commit
     * @param item
     */
    setIndividualItem ({ commit }, { item }) {
      commit(types.DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_SET_ITEM, { item })
    },
    /**
     * 個別削除
     * @param commit
     * @param item
     */
    removeIndividualItem ({ commit }, { item }) {
      commit(types.DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_REMOVE_ITEM, { item })
    },
    removeItem({ commit }, { item }) {
      commit(types.DRIVER_MANIFEST_LINKAGE_REMOVE_ITEM, { item })
    },
    allRemoveItems({ commit }) {
      commit(types.DRIVER_MANIFEST_LINKAGE_ALL_REMOVE_ITEMS)
    },
    /**
     * 検索条件に「２次委託量, ２次委託量単位が指定された際に
     * サーバから渡されたチェック情報を格納する.
     * @param commit
     * @param items
     */
    setCheckedTargetResults ({ commit }, {items}) {
      commit(types.DRIVER_MANIFEST_TARGET_CHECKED_ITEMS, { items })
    },
  },
  mutations: {
    /**
     * ２次委託量指定時、レスポンスにて設定された結果をセットする.
     * @param state
     * @param items
     */
    [types.DRIVER_MANIFEST_TARGET_CHECKED_ITEMS] (state, { items }) {
      state.checkedTargetResults = items
      for (const manifest of items) {
        // if (!state.selectedItems.includes(manifest.id)) {
        if (!state.selectedItems.includes(manifest.manifest_key)) {
          // state.selectedItems.push(manifest.id)
          state.selectedItems.push(manifest.manifest_key)
          const quantityTotal = (state.quantityTotal)
          state.quantityTotal = BigNumber(quantityTotal).plus(manifest.quantity)
        }
      }
    },
    /**
     * 個別, 一括でチェックされた際に
     * @param state
     * @param item
     */
    [types.DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_SET_ITEM] (state, { item }) {
      if (state.selectedItems.includes(item.id))
        return

      const quantityTotal = (state.quantityTotal)
      const total = BigNumber(quantityTotal).plus(item.quantity)
      state.quantityTotal = total <= 0 ? 0 : total

      state.selectedItems.push(item.id)
      state.individualItems.push(item.id)
    },
    /**
     * 一括でチェックを外す
     * @param state
     * @param item
     */
    [types.DRIVER_MANIFEST_LINKAGE_INDIVIDUAL_REMOVE_ITEM] (state, { item }) {
      state.selectedItems = state.selectedItems.filter(v => v !== item.id)
      state.individualItems = state.individualItems.filter(v => v !== item.id)
      const quantityTotal = (state.quantityTotal)
      const total = BigNumber(quantityTotal).minus(item.quantity)
      state.quantityTotal = total <= 0 ? 0 : total

    },
    /**
     * 個別でチェックを外す
     * @param state
     * @param id
     */
    [types.DRIVER_MANIFEST_LINKAGE_REMOVE_ITEM] (state, { item }) {
      if (state.selectedItems.includes(item.id)) {
        state.selectedItems = state.selectedItems.filter(v => v !== item.id)
        state.individualItems = state.individualItems.filter(v => v !== item.id)
        if (!state.individualItems.includes(item.id)) {
          const quantityTotal = (state.quantityTotal)
          const total = BigNumber(quantityTotal).minus(item.quantity)
          state.quantityTotal = total <= 0 ? 0 : total
        }
      }
    },
    /**
     * チェックボックス設定(全部チェック無にする)
     * @param state
     */
    [types.DRIVER_MANIFEST_LINKAGE_ALL_REMOVE_ITEMS] (state) {
      state.selectedItems = null
      state.individualItems = null
      state.selectedItems = []
      state.individualItems = []
      state.checkedTargetResults = []
      state.quantityTotal = 0
    },
    /**
     * 検索条件の設定
     * @param state
     * @param params
     */
    [types.DRIVER_MANIFEST_LINKAGE_CONDITION] (state, { conditions }) {
      Object.assign(state.condition, conditions)
    },
    /**
     * 検索条件のリセット
     * @param state
     */
    [types.DRIVER_MANIFEST_LINKAGE_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    /**
     * ページ情報の設定
     * @param state
     * @param content
     */
    [types.DRIVER_MANIFEST_LINKAGE_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    /**
     * ページ情報のリセット
     * @param state
     */
    [types.DRIVER_MANIFEST_LINKAGE_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
  },
}

export default manifest_linkage
